import React, { createContext, useState, useContext, Dispatch, SetStateAction } from 'react';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IntegrationDateObject } from '~/Models/DTO/Integration.model';

interface USCConnectContext {
  error: IErrorResponse | null;
  setError: Dispatch<SetStateAction<any>>;
  saveClicked: boolean;
  setSaveClicked: Dispatch<SetStateAction<boolean>>;
  dates: IntegrationDateObject;
  setDates: Dispatch<SetStateAction<IntegrationDateObject>>;
  selectedItem: string;
  setSelectedItem: Dispatch<SetStateAction<string>>;
  selectedClient: string;
  setSelectedClient: Dispatch<SetStateAction<string>>;
  selectedIntegrationId: string;
  setSelectedIntegrationId: Dispatch<SetStateAction<string>>;
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
  showRemovalModal: boolean;
  setShowRemovalModal: Dispatch<SetStateAction<boolean>>;
}

const USCConnectContext = createContext<USCConnectContext | undefined>(undefined);

export const useUSCConnectContext = () => useContext(USCConnectContext) as USCConnectContext;

export const USCConnectContextProvider: React.FC = ({ children }) => {
  const [error, setError] = useState<IErrorResponse | null>(null);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);
  const [dates, setDates] = useState<IntegrationDateObject>({
    startDate: '',
    endDate: '',
    initialStartDate: '',
    initialEndDate: '',
  });
  const [selectedItem, setSelectedItem] = useState<string>('');
  const [selectedClient, setSelectedClient] = useState<string>('');
  const [selectedIntegrationId, setSelectedIntegrationId] = useState<string>('');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [showRemovalModal, setShowRemovalModal] = useState<boolean>(false);

  return (
    <USCConnectContext.Provider
      value={{
        error,
        setError,
        saveClicked,
        setSaveClicked,
        dates,
        setDates,
        selectedItem,
        setSelectedItem,
        selectedClient,
        setSelectedClient,
        selectedIntegrationId,
        setSelectedIntegrationId,
        anchorEl,
        setAnchorEl,
        showRemovalModal,
        setShowRemovalModal,
      }}
    >
      {children}
    </USCConnectContext.Provider>
  );
};
